import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'clsx';
import { useApplicationParams, useLanguage } from '../../context';
import Icons from '../../constants/Icons';

const BackIcon = ({ className, isRtl, onClick }) => {
  const backIconClassName = classNames('back-div', className);

  return (
    <div className={backIconClassName} onClick={onClick}>
      <img alt="go-back" className="back-img" src={isRtl ? Icons.backAr : Icons.back} />
    </div>
  );
};

const BackHeader = ({
  className,
  title,
  offCanvas = false,
  closeContainer,
  url,
  direction,
  isLiveRoomsSection,
}) => {
  const navigate = useNavigate();

  const { isWeb } = useApplicationParams();
  const { isRtl } = useLanguage();

  const handleClick = () => {
    if (offCanvas) {
      return closeContainer?.(false);
    }

    if (isLiveRoomsSection && url) {
      return window.open(url, '_self');
    }

    navigate(url || -1);
  };

  const backHeaderSectionClassName = classNames(className, 'back-header-section', {
    'back-header-section-lg': isWeb,
  });

  return (
    <section dir={direction} className={backHeaderSectionClassName}>
      <div className="page-name-div">
        <BackIcon isRtl={isRtl} onClick={handleClick} />
        <p className="page-name">{title}</p>
        <BackIcon className="visibility-h" isRtl={isRtl} onClick={handleClick} />
      </div>
    </section>
  );
};

export default BackHeader;
